export default __webpack_public_path__ + "static/media/4_1_logo.8ab59aa7.png";